import { orderApi, type OrderVendorRow } from '../api/orderApi'
import { taskProgressWarnings, withProgressWarning, type DeleteTargetTask } from '../constants/taskDeleteWarning.logic'

/**
 * 공종 삭제 확인 — 기본 문구(buildTaskDeleteConfirm)에 '이미 진행된 일정' 경고를 붙여 브라우저 확인창으로 묻는다.
 * 발주 진행 상태는 누를 때 서버에서 새로 읽는다(다른 화면에서 방금 보낸 발주까지 반영). 발주 조회가 실패하면
 * 반장 경고만으로 묻는다 — 삭제 자체를 막지는 않는다. 간트(단건·여러 건)·캘린더 삭제가 같이 쓴다.
 */
export async function confirmTaskDelete(p: {
  scheduleId: number | null | undefined
  tasks: DeleteTargetTask[]
  base: string
}): Promise<boolean> {
  let rows: OrderVendorRow[] = []
  if (p.scheduleId != null) {
    try { rows = await orderApi.getOrderVendors(p.scheduleId) } catch { /* 발주 경고 없이 진행 */ }
  }
  return window.confirm(withProgressWarning(p.base, taskProgressWarnings(p.tasks, rows)))
}
